/** Derive avatar initials from explicit first/last, else from the full name.
 *
 *  Shared because both ends need the same answer: the SPA renders them live in
 *  avatars, and the API snapshots them onto a feedback comment so a canvas full
 *  of pins can draw its initials without an avatar-directory round trip. */
export function deriveInitials(full = '', first = '', last = '') {
    const fromParts = `${first.trim()[0] ?? ''}${last.trim()[0] ?? ''}`;
    if (fromParts)
        return fromParts.toUpperCase();
    const words = full.trim().split(/\s+/).filter(Boolean);
    const fromName = words.slice(0, 2).map((w) => w[0]).join('');
    return (fromName || '?').toUpperCase();
}
//# sourceMappingURL=initials.js.map